import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { addDisplayName } from "../Infra/display-name";
import { useViewModel } from "./useViewModel";
import { Parent } from "./HXMobilePage.styles";
import { LoadingPlaceholder } from "./LoadingPlaceholder";
import { PatientLogoutViewModel } from "./PatientLogoutViewModel";
export const PatientLogoutView = observer((props) => {
    const model = useViewModel(PatientLogoutViewModel, props.container);
    const { t } = useTranslation(["patients"]);
    return (_jsx(Parent, { style: { justifyContent: "center", alignItems: "center" }, children: model.showLoggingOutUI ? (_jsx(LoadingPlaceholder, { w: 10, h: 60, text: t("Logging out...") })) : (_jsx(LoadingPlaceholder, { w: 10, h: 60 })) }));
});
addDisplayName(PatientLogoutView, "PatientLogoutView");
